import React from "react";

const WorkArea = () => {
  return (
    <>
      {/* WORK AREA START */}

      <div className="work sp">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="heading1">
                <span
                  className="span"
                  data-aos="zoom-in-left"
                  data-aos-duration="700"
                >
                  <img src="/assets/img/icons/span1.png" alt="" /> Best It
                  Solution
                </span>
                <h2 className="title tg-element-title">
                  Let’s Elevate Your Business With Strategic API Solutions
                </h2>
                <div className="space16"></div>
                {/* <p data-aos="fade-right" data-aos-duration="700">At TechXen, we understand that every business is unique, which is why we offer a range of flexible IT solutions designed to address your specific challenges and goals.</p> */}

                <div
                  className="single-items"
                  data-aos="fade-right"
                  data-aos-duration="700"
                >
                  <div className="">
                    <div className="icon">
                      <img src="/assets/img/icons/work-iocn1.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4>Real Time Exchange Rates</h4>
                    <div className="space10"></div>
                    <p>
                      Get live interbank rates with our real time forex API,
                      delivering accurate pricing across global markets.
                    </p>
                  </div>
                </div>

                <div
                  className="single-items"
                  data-aos="fade-right"
                  data-aos-duration="900"
                >
                  <div className="">
                    <div className="icon">
                      <img src="/assets/img/icons/work-iocn2.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4>Minute wise historical data</h4>
                    <div className="space10"></div>
                    <p>
                      Access minute-by-minute historical trends via our forex
                      chart API for smarter trading and analysis.
                    </p>
                  </div>
                </div>

                <div
                  className="single-items"
                  data-aos="fade-right"
                  data-aos-duration="1100"
                >
                  <div className="">
                    <div className="icon">
                      <img src="/assets/img/icons/work-iocn3.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4>Latest Bid & Ask Values</h4>
                    <div className="space10"></div>
                    <p>
                      Our currency exchange API provides the latest bid and ask
                      values for over 200+ currency pairs in real time.
                    </p>
                  </div>
                </div>

                <div
                  className="single-items"
                  data-aos="fade-right"
                  data-aos-duration="1100"
                >
                  <div className="">
                    <div className="icon">
                      <img src="/assets/img/icons/work-iocn3.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4>Latest Mid Values</h4>
                    <div className="space10"></div>
                    <p>
                      Retrieve instant mid-market rates through our real time
                      forex API for fair pricing insights.
                    </p>
                  </div>
                </div>

                {/* <div
                  className="single-items"
                  data-aos="fade-right"
                  data-aos-duration="1100"
                >
                  <div className="">
                    <div className="icon">
                      <img src="/assets/img/icons/work-iocn3.png" alt="" />
                    </div>
                  </div>
                  <div className="">
                    <h4>Monthly & Broken Date Forward Premiums</h4>
                    <div className="space10"></div>
                    <p>
                      Track monthly and broken-date forward premiums with our
                      forex market data API to plan hedging strategies.
                    </p>
                  </div>
                </div> */}
              </div>
              <div className="space30"></div>
              {/* <div className="" data-aos="fade-right" data-aos-duration="800">
                  <a className="theme-btn1" href="#">Discover More <span><i className="fa-solid fa-arrow-right"></i></span></a>
                </div> */}
            </div>

            <div className="col-lg-6">
              <div className="work-images">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="image reveal image-anime">
                      <img src="/assets/img/work/work-img1.jpeg" alt="" />
                    </div>
                    <div className="image reveal image-anime">
                      <img src="/assets/img/work/work-img3.jpeg" alt="" />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="image reveal image-anime">
                      <img src="/assets/img/work/work-img2.png" alt="" />
                    </div>
                  </div>
                </div>
                <img
                  src="/assets/img/bg/work-bg.png"
                  alt=""
                  className="bg-image shape-animaiton4"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className="single-items col-12 col-md-6 col-lg-4"
              data-aos="fade-right"
              data-aos-duration="1100"
            >
              <div className="">
                <div className="icon">
                  <img src="/assets/img/icons/work-iocn3.png" alt="" />
                </div>
              </div>
              <div className="">
                <h4>
                  Rate Change Statistics: Daily, Weekly, Monthly & Yearly Rate
                  Change & Percentage
                </h4>
                <div className="space10"></div>
                <p>
                  Monitor forex trends using our forex live data API with
                  detailed rate change statistics and percentages.
                </p>
              </div>
            </div>

            <div
              className="single-items col-12 col-md-6 col-lg-4"
              data-aos="fade-right"
              data-aos-duration="1100"
            >
              <div className="">
                <div className="icon">
                  <img src="/assets/img/icons/work-iocn3.png" alt="" />
                </div>
              </div>
              <div className="">
                <h4>Daily OHCL Values- Open High Low & Close</h4>
                <div className="space10"></div>
                <p>
                  Get essential OHLC values daily with our exchange rate API for
                  technical forex analysis.
                </p>
              </div>
            </div>

            <div
              className="single-items col-12 col-md-6 col-lg-4"
              data-aos="fade-right"
              data-aos-duration="1100"
            >
              <div className="">
                <div className="icon">
                  <img src="/assets/img/icons/work-iocn3.png" alt="" />
                </div>
              </div>
              <div className="">
                <h4>More than 200+ currency pairs</h4>
                <div className="space10"></div>
                <p>
                  Our currency API covers 200+ currency pairs, offering the
                  widest forex market data API access.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* WORK AREA END */}
    </>
  );
};

export default WorkArea;
